var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconCLinkedin(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_851",
    "data-name": "Group 851",
    transform: "translate(1.255 1)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_12",
    "data-name": "Ellipse 12",
    transform: "translate(-0.255)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_33908",
    "data-name": "Path 33908",
    d: "M12.188-12.187H.935A.942.942,0,0,0,0-11.241V-.009A.942.942,0,0,0,.935.938H12.188a.944.944,0,0,0,.938-.946V-11.241A.944.944,0,0,0,12.188-12.187ZM3.967-.937H2.021V-7.2H3.97V-.937ZM2.994-8.057A1.128,1.128,0,0,1,1.866-9.185a1.128,1.128,0,0,1,1.128-1.128A1.13,1.13,0,0,1,4.122-9.185,1.127,1.127,0,0,1,2.994-8.057ZM11.259-.937H9.313V-3.984c0-.727-.015-1.661-1.011-1.661-1.014,0-1.169.791-1.169,1.608v3.1H5.188V-7.2H7.055v.855h.026A2.049,2.049,0,0,1,8.924-7.356c1.969,0,2.335,1.3,2.335,2.985Z",
    transform: "translate(8.677 21.69)",
    fill: "#fff"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCLinkedin);
export default __webpack_public_path__ + "static/media/icon_c_linkedin.18b2477454bc77fdf1a9e5423616fc0b.svg";
export { ForwardRef as ReactComponent };